import { createFileRoute } from "@tanstack/react-router";
import { PartyDetail } from "@/components/PartyDetail";

export const Route = createFileRoute("/_auth/customers/$customerId")({
  component: CustomerDetailPage,
});

function CustomerDetailPage() {
  const { customerId } = Route.useParams();
  return <PartyDetail partyId={customerId} partyType="customer" />;
}
